module.exports = __webpack_public_path__ + "static/media/DSC03543.ac575afe.JPG";